/*

    Форма ввода данных в обычный TextBox.
    Есть клавиатура

    при создании объекта, надо создать пропсы:
    
        - "SuccessEnter" - при успешном окончании ввода данных (функция)
        - "CancelEnter" - при отказе от ввода (функция)
*/


import './SelectAnimalModal.css';
import { useState, useEffect } from 'react'
import axios_sender from '../modules/axios_sender.js'
import unique from '../modules/unique.js';
import { getOld } from '../modules/date.js';
import { SetGlobalAnimal, ToAnimal } from '../modules/animal.js';
import { SetGlobalClient } from '../modules/client.js';



function SelectAnimalModal(props) {
 
    const [animal_list, SetAnimalList] = useState([]);                      // список животных клиента

    useEffect(() => { LoadAnimalsForClient(props.Client) }, [props.Client]);


  return (      
          <div className="wrap">
              <div className="modal">

                    <div className="captionsm">Выбор животного у владельца </div>
                    <div className="client-name">{ props.Client.name }</div>
                    { animal_list }

                    <br /> <br />
                    <div className="buttons">
                        <button type="button" className="btn btn-primary btn-lg" onClick={ () => props.CancelSelect() }>Отмена</button>
                        <button type="button" className="btn btn-warning btn-lg" onClick={ CreateNewAnimal }>Создать</button>
                    </div>
              </div>                        
          </div>
  );


  // запросить животных для владельца
  function LoadAnimalsForClient(client)
  {
        axios_sender({form: 'get_animals_for_client', id_client: client.ID}, LoadAnimalsForClientSuccess);
  }
  function LoadAnimalsForClientSuccess(data)
  {  
        let res = [];
        for(var i in data)
        {
            let animal =  ToAnimal(data[i]);
            res.push(fillOneAnimal(animal));
        }
        SetAnimalList(res);
  }

  // одно животное в списке
  function fillOneAnimal(animal)
  {
    let age = getOld(animal.animal_born);      // посчитаем возраст
    // класс для вывода пола животного
    let cns = "col-1 sex";
    if(animal.animal_sex.label == "М") cns += " men";
    else if(animal.animal_sex.label == "Ж") cns += " women";
    else if(animal.animal_sex.label) cns += " hz";

    return  <div key={ unique() } className="one-animal-select row d-flex align-items-center" onClick={() => ClickSelectAnimal(animal)}>
                <div className="col-2">{ animal.animal_type.label }</div>
                <div className="col-2">{ animal.animal_name }</div>
                <div className="col-2 animal-age">{ age }</div>
                <div className={ cns }></div>
                <div className="col-2">вес: {animal.animal_weight}</div>
            </div>
  }

  function ClickSelectAnimal(animal)
  {
        SetGlobalAnimal(animal);
        props.SelectedAnimalSuccess(animal);
  }

  // создать нового животного для владельца
  function CreateNewAnimal()
  {
        SetGlobalClient(props.Client);
        window.location.assign("newanimal");
  }

}

export default SelectAnimalModal;
